import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tominutes'
})
export class ToMinutes implements PipeTransform {

  transform(value: any, args?: any): any {
    return Math.round(value / 60);
  }

}
